(($) => {
  $(".unique-product-card-gallery-thumbs").each(function (i, el) {
    const $el = $(el);
    const pId = $el.closest(".product-card-gallery-cols").data("productId");
    $el.slick({
      infinite: false,
      slidesToShow: 4,
      // slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: $el.find(".product-card-gallery-prev"),
      nextArrow: $el.find(".product-card-gallery-next"),
      //centerMode: true,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      asNavFor: "#unique-product-card-gallery-slides-" + pId,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    });
  });

  $(".unique-product-card-gallery-slides").each(function (i, el) {
    const $el = $(el);
    const pId = $el.closest(".product-card-gallery-cols").data("productId");
    $el.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      // fade: true,
      swipe: false,
      //verticalSwiping: true,
      arrows: false,
      asNavFor: "#unique-product-card-gallery-thumbs-" + pId,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            verticalSwiping: false,
            swipe: false,
          },
        },
      ],
    });
  });
})(jQuery);
